import actionTypes from '../../action-types'

export default (userId) => ({
  type: actionTypes.USER.USER_GROUP_RELATIONS_FETCH,
  payload: {
    userId,
  },
})
